import { ESTADOS_CIVIS_SEM_CONJUGE } from "./fichaConstantes";

// ─────────────────────────────────────────────────────────────────────────────
// CHECKLISTS DE DOCUMENTOS
// Cada cenário possui sua própria lista.
// Nenhum documento é obrigatório como upload.
// Documento ausente será tratado por justificativa no momento do envio.
// ─────────────────────────────────────────────────────────────────────────────

export const CHECKLIST_LOCATARIO_PF_PADRAO = [
  {
    tipo: "CPF_RG_CNH",
    label: "RG e CPF ou CNH",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_ENDERECO",
    label: "Comprovante de endereço (Água, Luz, Gás, Etc …)",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_RENDA",
    label: "3 últimos comprovantes mensais de renda líquida",
    obrigatorio: false,
  },
  {
    tipo: "CERTIDAO_NASC_CASAMENTO",
    label: "Certidão de nascimento, Casamento ou União Estável",
    obrigatorio: false,
  },
  {
    tipo: "IRPF",
    label: "Declaração de IRPF com recibo de entrega",
    obrigatorio: false,
  },
  {
    tipo: "VINCULO_EMPREGATICIO",
    label: "Comprovante de vínculo empregatício (Carteira de trabalho, Contrato, Etc …)",
    obrigatorio: false,
  },
  {
    tipo: "MATRICULA_CAPACIDADE_ECON",
    label: "Matrícula atualizada do imóvel à título de capacidade econômica (NÃO É PARA FINS DE GARANTIA)",
    obrigatorio: false,
  },
  {
    tipo: "IPTU_CAPACIDADE_ECONOMICA",
    label: "Espelho do IPTU do imóvel à título de capacidade econômica (NÃO É PARA FINS DE GARANTIA)",
    obrigatorio: false,
  },
  {
    tipo: "FOTO_IMOVEL",
    label: "Foto do Imóvel",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_PATRIMONIO",
    label: "Comprovante de Patrimônio",
    obrigatorio: false,
  },
];

export const CHECKLIST_LOCATARIO_PJ_PADRAO = [
  {
    tipo: "CONTRATO_SOCIAL",
    label: "Contrato Social com nº JUCESP e últimas alterações",
    obrigatorio: false,
  },
  {
    tipo: "PROCURACAO",
    label: "Procuração indicando diretores autorizados a assinar o contrato de aluguel",
    obrigatorio: false,
  },
  {
    tipo: "CARTAO_CNPJ",
    label: "Cartão do CNPJ",
    obrigatorio: false,
  },
  {
    tipo: "FATURAMENTO_12M",
    label: "Faturamento dos últimos 12 meses assinado pelos responsáveis",
    obrigatorio: false,
  },
  {
    tipo: "BALANCO_BALANCETE",
    label: "Balanço ou balancete mais recente assinado pelo responsável",
    obrigatorio: false,
  },
  {
    tipo: "DOCS_AUTORIZADOS",
    label: "RG e CPF ou CNH dos autorizados a assinar",
    obrigatorio: false,
  },
  {
    tipo: "ENDERECO_AUTORIZADOS",
    label: "Comprovante de endereço dos autorizados a assinar (Água, Luz, Gás, Etc …)",
    obrigatorio: false,
  },
  {
    tipo: "MATRICULA_CAPACIDADE_ECON",
    label: "Matrícula atualizada do imóvel à título de capacidade econômica (NÃO É PARA FINS DE GARANTIA)",
    obrigatorio: false,
  },
  {
    tipo: "IPTU_CAPACIDADE_ECONOMICA",
    label: "Espelho do IPTU do imóvel à título de capacidade econômica (NÃO É PARA FINS DE GARANTIA)",
    obrigatorio: false,
  },
  {
    tipo: "FOTO_IMOVEL",
    label: "Foto do Imóvel",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_PATRIMONIO",
    label: "Comprovante de Patrimônio",
    obrigatorio: false,
  },
];

export const CHECKLIST_CONJUGE_LOCATARIO = [
  {
    tipo: "CPF_RG_CNH_CONJUGE",
    label: "RG e CPF ou CNH do cônjuge",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_RENDA_CONJUGE",
    label: "3 últimos comprovantes mensais de renda líquida",
    obrigatorio: false,
  },
  {
    tipo: "IRPF_CONJUGE",
    label: "Declaração de IRPF com recibo de entrega",
    obrigatorio: false,
  },
];

export const CHECKLIST_LOCATARIO_PF_IMOBILIARIA = [
  {
    tipo: "CPF_RG_CNH",
    label: "RG e CPF ou CNH",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_ENDERECO",
    label: "Comprovante de endereço (Água, Luz, Gás, Etc …)",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_RENDA",
    label: "3 últimos comprovantes mensais de renda líquida",
    obrigatorio: false,
  },
  {
    tipo: "CERTIDAO_NASC_CASAMENTO",
    label: "Certidão de nascimento, Casamento ou União Estável",
    obrigatorio: false,
  },
  {
    tipo: "IRPF",
    label: "Declaração de IRPF com recibo de entrega",
    obrigatorio: false,
  },
  {
    tipo: "VINCULO_EMPREGATICIO",
    label: "Comprovante de vínculo empregatício (Carteira de trabalho, Contrato, Etc …)",
    obrigatorio: false,
  },
  {
    tipo: "PATRIMONIO_CAPACIDADE_IMOB_1",
    label: "Comprovante de patrimônio à título de capacidade econômica",
    obrigatorio: false,
  },
  {
    tipo: "MATRICULA_CAPACIDADE_ECON",
    label: "Matrícula atualizada do imóvel à título de capacidade econômica",
    obrigatorio: false,
  },
  {
    tipo: "IPTU_CAPACIDADE_ECONOMICA",
    label: "Espelho do IPTU do imóvel à título de capacidade econômica",
    obrigatorio: false,
  },
  {
    tipo: "FOTO_IMOVEL",
    label: "Fotos do Imóvel",
    obrigatorio: false,
  },
  {
    tipo: "PATRIMONIO_CAPACIDADE_IMOB_2",
    label: "Comprovante de patrimônio à título de capacidade econômica",
    obrigatorio: false,
  },
];

export const CHECKLIST_FIADOR_PF = [
  {
    tipo: "CPF_RG_CNH",
    label: "RG e CPF ou CNH",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_ENDERECO",
    label: "Comprovante de endereço (Água, Luz, Gás, Etc …)",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_RENDA",
    label: "3 últimos comprovantes mensais de renda líquida",
    obrigatorio: false,
  },
  {
    tipo: "CERTIDAO_NASC_CASAMENTO",
    label: "Certidão de nascimento, Casamento ou União Estável",
    obrigatorio: false,
  },
  {
    tipo: "IRPF",
    label: "Declaração de IRPF com recibo de entrega",
    obrigatorio: false,
  },
  {
    tipo: "VINCULO_EMPREGATICIO",
    label: "Comprovante de vínculo empregatício (Carteira de trabalho, Contrato, Etc …)",
    obrigatorio: false,
  },
  {
    tipo: "ENDERECO_AUTORIZADOS",
    label: "Comprovante de endereço dos autorizados a assinar (Água, Luz, Gás, Etc …)",
    obrigatorio: false,
  },
  {
    tipo: "MATRICULA_CAPACIDADE_ECON",
    label: "Matrícula atualizada do imóvel à título de capacidade econômica",
    obrigatorio: false,
  },
  {
    tipo: "IPTU_CAPACIDADE_ECONOMICA",
    label: "Espelho do IPTU do imóvel à título de capacidade econômica",
    obrigatorio: false,
  },
  {
    tipo: "FOTO_IMOVEL",
    label: "Foto do Imóvel",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_PATRIMONIO",
    label: "Comprovante de Patrimônio",
    obrigatorio: false,
  },
];

export const CHECKLIST_FIADOR_PJ = [
  {
    tipo: "CONTRATO_SOCIAL",
    label: "Contrato Social com nº JUCESP e últimas alterações",
    obrigatorio: false,
  },
  {
    tipo: "PROCURACAO",
    label: "Procuração indicando diretores autorizados a assinar o contrato de aluguel",
    obrigatorio: false,
  },
  {
    tipo: "CARTAO_CNPJ",
    label: "Cartão do CNPJ",
    obrigatorio: false,
  },
  {
    tipo: "FATURAMENTO_12M",
    label: "Faturamento dos últimos 12 meses assinado pelos responsáveis",
    obrigatorio: false,
  },
  {
    tipo: "BALANCO_BALANCETE",
    label: "Balanço ou balancete mais recente assinado pelo responsável",
    obrigatorio: false,
  },
  {
    tipo: "DOCS_AUTORIZADOS",
    label: "RG e CPF ou CNH dos autorizados a assinar",
    obrigatorio: false,
  },
  {
    tipo: "ENDERECO_AUTORIZADOS",
    label: "Comprovante de endereço dos autorizados a assinar (Água, Luz, Gás, Etc …)",
    obrigatorio: false,
  },
  {
    tipo: "MATRICULA_CAPACIDADE_ECON",
    label: "Matrícula atualizada do imóvel à título de capacidade econômica",
    obrigatorio: false,
  },
  {
    tipo: "IPTU_CAPACIDADE_ECONOMICA",
    label: "Espelho do IPTU do imóvel à título de capacidade econômica",
    obrigatorio: false,
  },
  {
    tipo: "FOTO_IMOVEL",
    label: "Foto do Imóvel",
    obrigatorio: false,
  },
  {
    tipo: "COMPROVANTE_PATRIMONIO",
    label: "Comprovante de Patrimônio",
    obrigatorio: false,
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// FINS DE GARANTIA (rótulo dinâmico)
// Matrícula e IPTU do imóvel passam a ser "PARA FINS DE GARANTIA" quando a
// proposta indica imóvel na garantia:
//   - Locatária (PF ou PJ) com garantia Caução em Imóvel ("Imobiliária");
//   - Fiador com tipo de garantia COM IMÓVEL.
// Nos demais casos o imóvel é só capacidade econômica (NÃO É PARA FINS).
// O `tipo` do documento não muda — uploads já feitos continuam vinculados.
// ─────────────────────────────────────────────────────────────────────────────

const ROTULOS_FINS_GARANTIA = {
  MATRICULA_CAPACIDADE_ECON: {
    sim: "Matrícula atualizada do imóvel indicado em garantia (PARA FINS DE GARANTIA)",
    nao: "Matrícula atualizada do imóvel à título de capacidade econômica (NÃO É PARA FINS DE GARANTIA)",
  },
  IPTU_CAPACIDADE_ECONOMICA: {
    sim: "Espelho do IPTU do imóvel indicado em garantia (PARA FINS DE GARANTIA)",
    nao: "Espelho do IPTU do imóvel à título de capacidade econômica (NÃO É PARA FINS DE GARANTIA)",
  },
};

function normalizar(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();
}

export function propostaTemGarantiaImobiliaria(proposta) {
  return normalizar(proposta?.garantia)
    .split(",")
    .map((g) => g.trim())
    .includes("IMOBILIARIA");
}

export function propostaTemFiadorComImovel(proposta) {
  return normalizar(proposta?.fiadorTipoGarantia).replace(/\s+/g, "_") === "COM_IMOVEL";
}

export function fichaEhParaFinsDeGarantia(ficha, proposta) {
  if (!ficha) return false;
  if (ficha.campoProposta === "Locataria") return propostaTemGarantiaImobiliaria(proposta);
  if (ficha.campoProposta === "Fiador") return propostaTemFiadorComImovel(proposta);
  return false;
}

export function aplicarFinsGarantia(itens, paraFinsGarantia) {
  return (itens || []).map((item) => {
    const rotulos = ROTULOS_FINS_GARANTIA[item.tipo];
    if (!rotulos) return item;
    return { ...item, label: paraFinsGarantia ? rotulos.sim : rotulos.nao, paraFinsGarantia: !!paraFinsGarantia };
  });
}

export function obterGruposChecklistDocumentosFicha(ficha, proposta) {
  if (!ficha) {
    return [];
  }

  const garantiaImobiliaria = propostaTemGarantiaImobiliaria(proposta);

  const paraFinsGarantia = fichaEhParaFinsDeGarantia(ficha, proposta);

  const ehFiador = ficha.campoProposta === "Fiador";

  const ehLocatario = ficha.campoProposta === "Locataria";

  const ehPJ = ficha.tipoPessoa === "PJ";

  const ehPF = ficha.tipoPessoa === "PF";

  const grupos = [];

  // =========================================================
  // FIADOR PJ
  // =========================================================
  if (ehFiador && ehPJ) {
    grupos.push({
      chave: "FIADOR_PJ",
      titulo: "Fiador PJ",
      itens: aplicarFinsGarantia(CHECKLIST_FIADOR_PJ, paraFinsGarantia),
    });
  }

  // =========================================================
  // FIADOR PF
  // =========================================================
  else if (ehFiador && ehPF) {
    grupos.push({
      chave: "FIADOR_PF",
      titulo: "Fiador PF",
      itens: aplicarFinsGarantia(CHECKLIST_FIADOR_PF, paraFinsGarantia),
    });
  }

  // =========================================================
  // LOCATÁRIA PF - GARANTIA IMOBILIÁRIA
  // =========================================================
  else if (ehLocatario && ehPF && garantiaImobiliaria) {
    grupos.push({
      chave: "LOCATARIA_PF_IMOBILIARIA",
      titulo: "Locatária PF",
      itens: aplicarFinsGarantia(CHECKLIST_LOCATARIO_PF_IMOBILIARIA, paraFinsGarantia),
    });
  }

  // =========================================================
  // LOCATÁRIA PJ
  // =========================================================
  else if (ehLocatario && ehPJ) {
    grupos.push({
      chave: "LOCATARIA_PJ",
      titulo: "Locatária PJ",
      itens: aplicarFinsGarantia(CHECKLIST_LOCATARIO_PJ_PADRAO, paraFinsGarantia),
    });
  }

  // =========================================================
  // LOCATÁRIA PF
  // =========================================================
  else if (ehLocatario && ehPF) {
    grupos.push({
      chave: "LOCATARIA_PF",
      titulo: "Locatária PF",
      itens: aplicarFinsGarantia(CHECKLIST_LOCATARIO_PF_PADRAO, paraFinsGarantia),
    });
  }

  // =========================================================
  // CÔNJUGE
  // CHECKLIST SEPARADO
  // SOMENTE LOCATÁRIA PF QUANDO APLICÁVEL
  // =========================================================
  if (ehLocatario && ehPF && ficha.pfEstadoCivil && !ESTADOS_CIVIS_SEM_CONJUGE.includes(ficha.pfEstadoCivil)) {
    grupos.push({
      chave: "CONJUGE_LOCATARIA",
      titulo: "Cônjuge",
      itens: [...CHECKLIST_CONJUGE_LOCATARIO],
    });
  }

  return grupos;
}
